import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (
      req.url.includes('skikc01.next-gen-solutions.de') ||
      req.url.includes('skikc01.skiworld.online') ||
      req.url.includes('skikc01.skiworld.at') ||
      req.url.includes('assets/') ||
      req.url.includes('geolocation-db.com') ||
      req.url.includes('router.project-osrm.org') ||
      req.url.includes('m.stripe.com')
    ) {
      return next.handle(req);
    }

    const access_token = localStorage.getItem('access_token') as string | null;

    const headersConfig: Record<string, string> = {
      'Accept-Language': localStorage.getItem('locale') || 'de',
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      'Pragma': 'no-cache',
    };

    if (access_token) {
      headersConfig['Authorization'] = `Bearer ${access_token}`;
    }

    const authReq = req.clone({ setHeaders: headersConfig });

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.status === 403) {
          localStorage.removeItem(`id_token`);
          localStorage.removeItem(`email`);
        }
        return throwError(() => err);
      })
    );
  }
}
